
define("bundles/shared", function(){});
